import {
    Autocomplete,
    Box,
    Button,
    FormControl,
    FormLabel,
    Grid,
    MenuItem,
    Paper,
    Stack,
    TextField,
    Typography
} from "@mui/material";
import {
    Add,
    Archive,
    ArrowBack,
    CheckCircleRounded,
    DeleteRounded,
    DescriptionRounded,
    Edit,
} from "@mui/icons-material";
import * as React from "react";
import {useContext, useEffect, useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import IconButton from "@mui/material/IconButton";
import SectionHeader from "../../../../util/component/SectionHeader";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {Controller, useForm} from "react-hook-form";
import CustomModalBL from "../../component/CustomModalBL";
import {useBlackListActions} from "../../service/useBlackListActions";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import {GlobalContext} from "../../../../util/state/GlobalContextProvider";
import {yupResolver} from "@hookform/resolvers/yup";
import {
    CausalInterface,
    ClientTypeInterface,
    CustomerDetail,
    EntrySourceInterface,
    FCABankInterface
} from "../../component/BlackListInterfaces";
import {useCausalValues} from "../../component/useCausalValues";
import {useClientTypeValues} from "../../component/useClientTypeValues";
import {setSnackbar} from "../../../../util/state/globalAction";
import {snackbarTypes} from "../../../../util/state/globalVariables";
import {DatePicker} from "@mui/x-date-pickers";
import {AUTOMATIC, FCA_BANK, MAIL_ADDRESS_REG_EXP, MANUAL, TELEPHONE_REG_EXP} from "../../component/Constants";
import AgGridCustomTable from "../../../../util/component/AgGridCustomTable";
import {ColDef, GetRowIdParams, GridOptions, ICellRendererParams} from "ag-grid-enterprise";
import {useAgGridLocale, useHasScope} from "../../../../config/globalConfig";
import {AgGridReact} from "ag-grid-react";
import {useEntrySourceValues} from "../../component/useEntrySourceValues";
import * as Yup from "yup";
import {useFCABankValues} from "../../component/useFCABankValues";
import dayjs from "dayjs";
import RadioGroupComponent from "../../component/RadioGroupComponent";
import {
    BLACK_LIST_SCOPE_ARCHIVE,
    BLACK_LIST_SCOPE_CREATE, BLACK_LIST_SCOPE_DETAIL_BL,
    BLACK_LIST_SCOPE_EDIT
} from "../../component/utils/AuthConstants";
import NotAuthorizedDialog from "../../../authentication/component/NotAuthorizedDialog";
import * as yup from "yup";

const BlackListDetailPage = (props: any) => {
    type Nullable<T> = T | null;
    const {t} = useTranslation(['finessecurity'], {keyPrefix: 'blackList'});
    const tr = useTranslation(['translation']);
    const hasScope = useHasScope;
    // const backToBlackList = "/finessecurity/watchlist";
    // const backtoArchived = "/finessecurity/watchlist/archived";
    const navigate = useNavigate();
    const location = useLocation();
    const locationState = (location.state as Nullable<{ customer: any | undefined, id: any | undefined }>);
    const customerDetailsExternal = locationState?.customer;
    const {id} = useParams();
    //newCustomer pilot the new customer view
    const [newCustomer, setNewCustomer] = useState(props.newCustomer);
    const extCustomerType = props.extCustomerType;
    //isReadonly pilot the view/edit of detail page
    const [isReadonly, setIsReadonly] = useState(true);
    //isArchived pilot the detailPage of a blacklist/archived
    const [isArchived, setIsArchived] = useState(false);
    //isPrivate pilot the detailPage of a customer/company
    const [isPrivateCustomer, setIsPrivateCustomer] = useState(true);
    const [personView, setPersonView] = useState<string>("person");
    const [customer, setCustomer] = useState<CustomerDetail | null>(null);

    const [openCancelAddCustomer, setOpenCancelAddCustomer] = useState(false);
    const [openCreationModalError, setOpenCreationModalError] = useState(false);
    const [openTaxCodeModalError, setOpenTaxCodeModalError] = useState(false);
    const [openCreationModal, setOpenCreationModal] = useState(false);
    const [openArchiveModal, setOpenArchiveModal] = useState(false);
    const [openDeleteAttachmentModal, setOpenDeleteAttachmentModal] = useState(false);
    const [attachmnetTableShouldUpdate, setAttachmnetTableShouldUpdate] = useState(false);
    const [fileForImport, setAttachment] = useState<File | undefined>(undefined);
    const {globalData, dispatchGlobalData} = useContext(GlobalContext);
    const agGridLocale = useAgGridLocale();
    const gridRef = useRef<AgGridReact>(null);
    const [uploadErrorMessage, setUploadErrorMessage] = useState<string>("");
    const [openUploadWarning, setOpenUploadWarning] = useState(false);
    const {
        getBlackListDetail, getCausalValues, getClientType, getCustomerByButton, getFCACodes,
        getEntrySource, updateCustomer, createCustomer, addAttachment, getSingleAttachment, deleteBlackListAttachment,
        archiveCustomer
    } = useBlackListActions();
    const [causalValues, setCausalValues] = useState<CausalInterface[]>([]);
    const [client_type, setClientType] = useState<ClientTypeInterface[]>([]);
    const [entrySource, setEntrySource] = useState<EntrySourceInterface[]>([]);
    const [fcaBank, setFcaBank] = useState<FCABankInterface[]>([]);
    const [isFCABankOrigin, setIsFCABankOrigin] = useState<boolean>(false);
    const {getClientTypeLabel} = useClientTypeValues();
    const {getCausalLabel} = useCausalValues();
    const {getEntrySourcelLabel} = useEntrySourceValues();
    const {getFCABankLabel} = useFCABankValues();
    const [attachmentRowId, setAttachmentRowId] = useState<number>();
    const [attachmentRowName, setAttachmentRowName] = useState<string>();

    useEffect(() => {
        if (id) { // retrieve customer
            getBlackListDetail(id).then(res => {
                setCustomer(res);
            });
        }
        getCausalValues().then((res: any) => {
            setCausalValues(res.data);
        });
        getClientType().then((res: any) => {
            setClientType(res.data);
        });
        getEntrySource().then((res: any) => {
            setEntrySource(res.data);
        });
        getFCACodes().then((res: any) => {
            setFcaBank(res.data);
        });

        if (customerDetailsExternal) {
            setNewCustomer(true);
        }
    }, []);


    const [radioButtonOptions] = useState<{ id: string, label: string }[]>([{
        id: "person",
        label: `${t("buttons.person")}`
    }, {
        id: "company",
        label: `${t("buttons.company")}`
    }]);

    useEffect(() => {
        if (newCustomer) {
            setIsReadonly(false);
        }
    }, [newCustomer])

    useEffect(() => {
        setNewCustomer(props.newCustomer)
    }, [props.newCustomer])


    const handleChangeRadioGroup = (e: any, value: string) => {
        reset(retrieveInitialValues());
        setPersonView(value);
        if (value === "person") {
            setIsPrivateCustomer(true);
        } else {
            setIsPrivateCustomer(false);
        }
    };

    useEffect(() => {
        if (customer) {
            reset(retrieveInitialValues());
            setIsArchived(customer.is_archived);
            setIsPrivateCustomer(!customer.vat_number);
            setIsFCABankOrigin(customer.entry_origin.entry_origin_code === FCA_BANK);
            setAttachmnetTableShouldUpdate(true);
        }
    }, [customer, isPrivateCustomer])

    const columns: ColDef[] = [
        {
            field: "name",
            headerName: t('label.name'),
            unSortIcon: true,
            tooltipField: "name",
        },
        {
            field: "update_datetime",
            headerName: t('label.updateDate'),
            cellRenderer: (params: any) => params.value ? dayjs(params.value).format("L") : "",
            unSortIcon: true,
        },
        {
            field: "_actions",
            headerName: t('listColumns.action'),
            pinned: 'right',
            lockPosition: 'right',
            lockPinned: true,
            sortable: false,
            width: 100,
            cellRenderer: (params: ICellRendererParams) => {
                return (
                    <Box display="flex" justifyContent="center" alignItems="center">
                        {hasScope(BLACK_LIST_SCOPE_DETAIL_BL) &&
                            <IconButton title="Details" color="accent"
                                        onClick={() => {
                                            getSingleAttachment(params.data.id, id).then((res) => {
                                                if (res) {
                                                    const file = new Blob([res], {type: res.type});
                                                    const fileURL = URL.createObjectURL(file);
                                                    const pdfWindow = window.open("");
                                                    if (pdfWindow) {
                                                        pdfWindow.location.href = fileURL;
                                                    }
                                                }
                                            });
                                        }}>
                                <DescriptionRounded/>
                            </IconButton>}

                        {!customer?.is_archived &&
                            <>
                                {hasScope(BLACK_LIST_SCOPE_EDIT) &&
                                    <IconButton
                                        color={"accent"}
                                        aria-label="delete"
                                        onClick={(event) => {
                                            setAttachmentRowId(params.data.id);
                                            setAttachmentRowName(params.data.name);
                                            setOpenDeleteAttachmentModal(true);
                                        }}>
                                        <DeleteRounded/>
                                    </IconButton>}
                            </>
                        }
                    </Box>
                )
            }
        }
    ]

    const toolbar = {
        renderActions: () =>
            <>
                {(!isArchived && hasScope(BLACK_LIST_SCOPE_EDIT)) &&
                    <Button size="small" component="label">
                        <Add fontSize="small"/>{t('buttons.addAttachment')}
                        <input onChange={(event) => {
                            setAttachment(event?.target?.files?.[0]);
                            const element = event.target as HTMLInputElement;
                            element.value = '';
                        }} hidden accept=".pdf, image/png, image/jpeg, image/jpg" multiple type="file"/>
                    </Button>
                }
            </>,
        renderInfo: () =>
            <Typography align="left">{t('attachment')}</Typography>

    }

    const gridOptions: GridOptions = {
        getRowId: (params: GetRowIdParams) => params.data['id'],
        suppressRowClickSelection: true,
        domLayout: 'autoHeight',
        pagination: false,
        cacheBlockSize: 10,
        defaultColDef: {
            sortable: true,
            resizable: false,
            wrapHeaderText: true,
            autoHeight: true,
        },
        columnDefs: columns,
        serverSideInfiniteScroll: false,
        localeText: agGridLocale,
    };

    useEffect(() => {
        if (fileForImport) {
            let fileExtension = fileForImport.name.split('.').pop();
            if (['pdf', 'jpeg', 'jpg', 'png'].includes(fileExtension!.toLowerCase())) {
                addAttachment(fileForImport, id)
                    .then(response => {
                        if (response.name !== "") {
                            dispatchGlobalData({
                                type: setSnackbar,
                                payload: {
                                    snackbar: {
                                        message: t("updateForm.successImport"),
                                        type: snackbarTypes.success,
                                        show: true,
                                        autoClose: true,
                                    }
                                }
                            });
                            getBlackListDetail(id).then(res => {
                                console.log('BlackListDetailPage getBlackListDetail (2) res: ' + JSON.stringify(res));
                                setCustomer(res);
                            });

                        } else {
                            if (response.message) {
                                // specific error
                                setUploadErrorMessage(t(`importErrors.${response.message}`));
                            } else {
                                // generic error
                                setUploadErrorMessage(t("importErrors.generic"));
                            }
                            setOpenUploadWarning(true);
                        }
                    })
                    .finally(() => {
                        setAttachment(undefined);
                    });
            } else {
                setUploadErrorMessage(t('importErrors.wrongFileFormat'));
                setOpenUploadWarning(true);
                setAttachment(undefined);
            }
        }
    }, [fileForImport])

    const retrieveInitialValues = () => {
        if (customer) {
            return {
                id: customer.id ? customer.id : "",
                is_archived: isArchived,
                date_start_bl: customer.date_start_bl ? customer.date_start_bl : null,
                first_name: customer.first_name ? customer.first_name : "",
                last_name: customer.last_name ? customer.last_name : "",
                full_name: customer.full_name ? customer.full_name : "",
                birth_date: customer.birth_date ? customer.birth_date : null,
                birth_place: customer.birth_place ? customer.birth_place : "",
                birth_county: customer.birth_county ? customer.birth_county : "",
                birth_country: customer.birth_country ? customer.birth_country : "",
                tax_code: customer.tax_code ? customer.tax_code : "",
                vat_number: customer.vat_number ? customer.vat_number : "",
                license_number: customer.license_number ? customer.license_number : "",
                prefix_number: customer.prefix_number ? customer.prefix_number : "",
                telephone_number: customer.telephone_number ? customer.telephone_number : "",
                email: customer.email ? customer.email : "",
                client_type: customer.client_type ? customer.client_type : "",
                causal: customer.causal ? customer.causal : "",
                notes: customer.notes ? customer.notes : "",
                entry_user_bl: customer.entry_user_bl ? customer.entry_user_bl : "",
                entry_origin: customer.entry_origin ? customer.entry_origin : "",
                attachments: customer.attachments ? customer.attachments : [],
                create_datetime: customer.create_datetime ? customer.create_datetime : null,
                update_datetime: customer.update_datetime ? customer.update_datetime : null,
                date_end_bl: customer.date_end_bl ? customer.date_end_bl : null,
                business_name: customer.business_name ? customer.business_name : "",
                fca_notes: customer.fca_notes ? customer.fca_notes : "",
                fca_description: customer.fca_description ? customer.fca_description : "",
                siren: customer.siren ? customer.siren : "",
                siret: customer.siret ? customer.siret : "",
            };
        } else if (customerDetailsExternal) {

            return {
                date_start_bl: dayjs().toDate(),
                entry_origin: {entry_origin_code: AUTOMATIC},
                first_name: customerDetailsExternal.firstName ? customerDetailsExternal.firstName : "",
                last_name: customerDetailsExternal.lastName ? customerDetailsExternal.lastName : "",
                birth_date: customerDetailsExternal.birthDate ? customerDetailsExternal.birthDate : null,
                birth_place: customerDetailsExternal.birthPlace ? customerDetailsExternal.birthPlace?.description : "",
                birth_county: customerDetailsExternal.birthCounty ? customerDetailsExternal.birthCounty : "",
                birth_country: customerDetailsExternal.birthNation ? customerDetailsExternal.birthNation?.description : "",
                tax_code: customerDetailsExternal.fiscalCode ? customerDetailsExternal.fiscalCode : "",
                license_number: customerDetailsExternal.drivingLicenseNumber ? customerDetailsExternal.drivingLicenseNumber : "",
                prefix_number: customerDetailsExternal.prefixNumber ? customerDetailsExternal.prefixNumber : "",
                telephone_number: customerDetailsExternal.mobile ? customerDetailsExternal.mobile.replaceAll(" ", "") : "",
                email: customerDetailsExternal.email ? customerDetailsExternal.email : "",
                siren: customerDetailsExternal.siren ? customerDetailsExternal.siren : "",
                siret: customerDetailsExternal.siret ? customerDetailsExternal.siret : "",
            }
        } else {
            return {
                id: "",
                is_archived: false,
                date_start_bl: null,
                first_name: "",
                last_name: "",
                full_name: "",
                birth_date: null,
                birth_place: "",
                birth_county: "",
                birth_country: "",
                tax_code: "",
                vat_number: "",
                license_number: "",
                prefix_number: "",
                telephone_number: "",
                email: "",
                client_type: {client_type_code: ""},
                causal: {causal_code: ""},
                notes: "",
                entry_user_bl: "",
                entry_origin: {entry_origin_code: ""},
                attachments: [],
                create_datetime: null,
                update_datetime: null,
                date_end_bl: null,
                business_name: "",
                fca_notes: "",
                fca_description: "",
                siren: "",
                siret: "",
            };
        }
    }

    const validationSchema = Yup.object({
        date_start_bl: Yup.date().typeError(t('createForm.invalidDate')).required(t('createForm.requiredCheck')),
        first_name: Yup.string().required(t('createForm.requiredCheck')),
        last_name: Yup.string().required(t('createForm.requiredCheck')),
        birth_date: Yup.date().typeError(t('createForm.invalidDate')).required(t('createForm.requiredCheck')),
        birth_place: Yup.string().required(t('createForm.requiredCheck')),
        birth_county: Yup.string().required(t('createForm.requiredCheck')),
        birth_country: Yup.string().required(t('createForm.requiredCheck')),
        // tax_code: Yup.string().required(t('createForm.requiredCheck')),
        license_number: Yup.string().required(t('createForm.requiredCheck')),
        telephone_number: Yup.string().matches(TELEPHONE_REG_EXP, {
            excludeEmptyString: true,
            message: t('createForm.onlyNumbers')
        }).required(t('createForm.requiredCheck')),
        email: Yup.string().matches(MAIL_ADDRESS_REG_EXP, {
            excludeEmptyString: true,
            message: t('createForm.emailNotValid')
        }).required(t('createForm.requiredCheck')),
        client_type: Yup.object().shape({client_type_code: Yup.string().required(t('createForm.requiredCheck'))}),
        causal: Yup.object().shape({causal_code: Yup.string().required(t('createForm.requiredCheck'))})
    });

    const validationSchemaCompany = Yup.object({
        date_start_bl: Yup.date().typeError(t('createForm.invalidDate')).required(t('createForm.requiredCheck')),
        business_name: Yup.string().required(t('createForm.requiredCheck')),
        vat_number: Yup.string().required(t('createForm.incorrectEntry')),
        telephone_number: Yup.string().matches(TELEPHONE_REG_EXP, {
            excludeEmptyString: true,
            message: t('createForm.onlyNumbers')
        }).required(t('createForm.requiredCheck')),
        email: Yup.string().matches(MAIL_ADDRESS_REG_EXP, {
            excludeEmptyString: true,
            message: t('createForm.emailNotValid')
        }).required(t('createForm.requiredCheck')),
        client_type: Yup.object().shape({client_type_code: Yup.string().required(t('createForm.requiredCheck'))}),
        causal: Yup.object().shape({causal_code: Yup.string().required(t('createForm.requiredCheck'))})
    });

    const validationSchemaFCABankPrivate = Yup.object({
        date_start_bl: Yup.date().typeError(t('createForm.invalidDate')).required(t('createForm.requiredCheck')),
        full_name: Yup.string().required(t('createForm.requiredCheck')),
        // tax_code: Yup.string().required(t('createForm.requiredCheck')),
        telephone_number: Yup.string().matches(TELEPHONE_REG_EXP, {
            excludeEmptyString: true,
            message: t('createForm.onlyNumbers')
        }).required(t('createForm.requiredCheck')),
        email: Yup.string().matches(MAIL_ADDRESS_REG_EXP, {
            excludeEmptyString: true,
            message: t('createForm.emailNotValid')
        }).required(t('createForm.requiredCheck')),
        client_type: Yup.object().shape({client_type_code: Yup.string().required(t('createForm.requiredCheck'))}),
        causal: Yup.object().shape({causal_code: Yup.string().required(t('createForm.requiredCheck'))})
    });

    const validationSchemaFCABankCompany = Yup.object({
        date_start_bl: Yup.date().typeError(t('createForm.invalidDate')).required(t('createForm.requiredCheck')),
        full_name: Yup.string().required(t('createForm.requiredCheck')),
        vat_number: Yup.string().required(t('createForm.incorrectEntry')),
        telephone_number: Yup.string().matches(TELEPHONE_REG_EXP, {
            excludeEmptyString: true,
            message: t('createForm.onlyNumbers')
        }).required(t('createForm.requiredCheck')),
        email: Yup.string().matches(MAIL_ADDRESS_REG_EXP, {
            excludeEmptyString: true,
            message: t('createForm.emailNotValid')
        }).required(t('createForm.requiredCheck')),
        client_type: Yup.object().shape({client_type_code: Yup.string().required(t('createForm.requiredCheck'))}),
        causal: Yup.object().shape({causal_code: Yup.string().required(t('createForm.requiredCheck'))})
    });

    const {handleSubmit, control, watch, reset, formState, setError, clearErrors, getValues} = useForm({
        defaultValues: retrieveInitialValues(),
        resolver: isPrivateCustomer ?
            (isFCABankOrigin ? yupResolver(validationSchemaFCABankPrivate) : yupResolver(validationSchema)) :
            (isFCABankOrigin ? yupResolver(validationSchemaFCABankCompany) : yupResolver(validationSchemaCompany))
    });

    const {isDirty: formIsDirty} = formState;


    const onSubmit = (values: any) => {
        let payload = {...values};
        checkList(payload) ? addOrUpdateCustomer(payload) : setOpenTaxCodeModalError(true);
    }

    function checkList(payload: any) {
        let result = {isOk: true};
        // other checks
        if (payload.tax_code === "" && isPrivateCustomer) {
            result.isOk = false;
        } else {
            result.isOk = true;
        }
        return result.isOk;
    }

    const addOrUpdateCustomer = async (payload: any) => {
        if (newCustomer) {
            if (!customerDetailsExternal)
                payload.entry_origin = {entry_origin_code: MANUAL}
            let data = await createCustomer(payload);
            if (data && data.status === "OK") {
                dispatchGlobalData({
                    type: setSnackbar,
                    payload: {
                        snackbar: {
                            message: t("updateForm.customerAddedMsg"),
                            type: snackbarTypes.success,
                            show: true,
                            autoClose: true,
                        }
                    }
                });
                setIsReadonly(prevState => !prevState);
                customerDetailsExternal ?
                    navigate(-1)
                    : navigate(`/finessecurity/watchlist`);
            } else {
                dispatchGlobalData({
                    type: setSnackbar,
                    payload: {
                        snackbar: {
                            message: t(`snackBarErrors.${data.message}`),
                            type: snackbarTypes.error,
                            show: true,
                            autoClose: true,
                        }
                    }
                });
            }

        } else {
            let data = await updateCustomer(payload);
            if (data && data.status === "OK") {
                dispatchGlobalData({
                    type: setSnackbar,
                    payload: {
                        snackbar: {
                            message: t("updateForm.modalTitleSuccess"),
                            type: snackbarTypes.success,
                            show: true,
                            autoClose: true,
                        }
                    }
                });
                setIsReadonly(prevState => !prevState);
                customerDetailsExternal ?
                    navigate(-1)
                    : navigate(`/finessecurity/watchlist/detail/${customer?.id}`);
            } else {
                dispatchGlobalData({
                    type: setSnackbar,
                    payload: {
                        snackbar: {
                            message: t(`snackBarErrors.${data.message}`),
                            type: snackbarTypes.error,
                            show: true,
                            autoClose: true,
                        }
                    }
                });
                getBlackListDetail(id).then(res => {
                    setCustomer(res);
                });
            }
        }

    }


    return (
        <>
            <SectionHeader title={t(newCustomer ? 'listHeader.addCustomerTitle' : 'listHeader.title')}
                           subtitle={t(newCustomer ? 'listHeader.addCustomerSubTitle' : 'listHeader.subTitle')}/>
            <Paper elevation={3} sx={{padding: "16px", margin: "18px"}}>
                {(newCustomer && hasScope(BLACK_LIST_SCOPE_CREATE) || (!newCustomer && hasScope(BLACK_LIST_SCOPE_DETAIL_BL))) ?
                    <form onSubmit={handleSubmit(data => {
                        onSubmit({...data});
                    }, errors => console.log(errors))} noValidate>
                        {customer || newCustomer ?
                            <>
                                <Stack direction="row" alignItems="end" columnGap={1}>
                                    {newCustomer ?
                                        <Grid>
                                            {!customerDetailsExternal &&
                                                <Grid item xs={12}>
                                                    <FormControl>
                                                        <FormLabel
                                                            id="demo-radio-buttons-group-label">{t('listHeader.fillFormMsg').toUpperCase()}</FormLabel>
                                                        <RadioGroupComponent
                                                            name={"addCustomerButton"}
                                                            handleChange={handleChangeRadioGroup}
                                                            options={radioButtonOptions}
                                                            disabled={false} value={personView}/>
                                                    </FormControl>

                                                </Grid>}
                                        </Grid>
                                        :
                                        <>
                                            {isReadonly &&

                                                <Grid container item spacing={2} alignItems={'center'}>
                                                    <Grid item xs={12}>
                                                        <Typography variant={'body2'} color={'primary.light'} fontWeight={700} textTransform={'uppercase'}>
                                                            {customer ?
                                                                (isPrivateCustomer ?
                                                                    customer.last_name && customer.first_name ?
                                                                        (customer.last_name + " " + customer.first_name) :
                                                                        customer.full_name : customer.business_name) : ""
                                                            }
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            }
                                            {!isReadonly &&
                                                <Grid container item spacing={2} alignItems={'center'}>
                                                    <Grid item xs={12}> {t('listHeader.titleEdit')} </Grid>
                                                </Grid>
                                            }
                                        </>
                                    }
                                </Stack>


                                {!newCustomer &&
                                    <>
                                        {!isArchived &&
                                            <>
                                                {isReadonly &&
                                                    <Grid container rowSpacing={3} columnSpacing={3} sx={{paddingTop: "10px"}}>
                                                        <Grid container item xs={12} rowSpacing={1} columnSpacing={3}
                                                              justifyContent={"flex-end"}>
                                                            {hasScope(BLACK_LIST_SCOPE_EDIT) &&
                                                                <Button size={"small"} variant="contained"
                                                                        onClick={() => setIsReadonly(prevState => !prevState)}
                                                                >
                                                                    <Edit fontSize="small"/> {t('buttons.edit')}
                                                                </Button>}

                                                        </Grid>
                                                    </Grid>
                                                }
                                            </>
                                        }
                                    </>
                                }


                                <Grid container rowSpacing={3} columnSpacing={3}>
                                    <Grid item xs={3}>
                                        <Controller
                                            control={control}
                                            name={"date_start_bl"}
                                            render={({field, fieldState}) => (
                                                <DatePicker
                                                    label={t('editBlackList.blStartDate')}
                                                    value={field.value}
                                                    onChange={field.onChange}
                                                    disabled={isReadonly}
                                                    renderInput={(params) =>
                                                        <TextField
                                                            {...params}
                                                            fullWidth
                                                            required={!isReadonly}
                                                            disabled={isReadonly}
                                                            error={!!fieldState.error}
                                                            helperText={fieldState.error?.message}/>
                                                    }
                                                    inputFormat={"L"}
                                                />
                                            )}
                                        />
                                    </Grid>

                                    {/*Manage Private Customer View*/}
                                    {isPrivateCustomer ?
                                        <>
                                            {isFCABankOrigin ?
                                                <Grid item xs={3}>
                                                    <Controller
                                                        control={control}
                                                        name={"full_name"}
                                                        render={({field, fieldState}) => (
                                                            <TextField fullWidth label={t('editBlackList.nameFCA')}
                                                                       value={field.value} margin="dense"
                                                                       variant="standard"
                                                                       disabled={!newCustomer}
                                                                       onChange={field.onChange}
                                                                       required={newCustomer}
                                                                       error={!!fieldState.error}
                                                                       helperText={fieldState.error?.message}
                                                            />
                                                        )}/>
                                                </Grid>
                                                :
                                                <>
                                                    <Grid item xs={3}>
                                                        <Controller
                                                            control={control}
                                                            name={"first_name"}
                                                            render={({field, fieldState}) => (
                                                                <TextField fullWidth
                                                                           label={t('editBlackList.firstName')}
                                                                           value={field.value} margin="dense"
                                                                           variant="standard"
                                                                           disabled={!newCustomer}
                                                                           onChange={field.onChange}
                                                                           required={newCustomer}
                                                                           error={!!fieldState.error}
                                                                           helperText={fieldState.error?.message}/>
                                                            )}/>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <Controller
                                                            control={control}
                                                            name={"last_name"}
                                                            render={({field, fieldState}) => (
                                                                <TextField fullWidth label={t('editBlackList.lastName')}
                                                                           value={field.value} margin="dense"
                                                                           variant="standard"
                                                                           disabled={!newCustomer}
                                                                           onChange={field.onChange}
                                                                           required={newCustomer}
                                                                           error={!!fieldState.error}
                                                                           helperText={fieldState.error?.message}/>
                                                            )}/>
                                                    </Grid>
                                                </>
                                            }
                                            {!isFCABankOrigin &&
                                                <>
                                                    <Grid item xs={3}>
                                                        <Controller
                                                            control={control}
                                                            name={"birth_date"}
                                                            render={({field, fieldState}) => (
                                                                <DatePicker
                                                                    label={t('editBlackList.birthDate')}
                                                                    value={field.value}
                                                                    onChange={field.onChange}
                                                                    disabled={!newCustomer}
                                                                    renderInput={(params) =>
                                                                        <TextField
                                                                            {...params}
                                                                            fullWidth
                                                                            required={newCustomer}
                                                                            disabled={!newCustomer}
                                                                            error={!!fieldState.error}
                                                                            helperText={fieldState.error?.message}/>
                                                                    }
                                                                    inputFormat={"L"}
                                                                />
                                                            )}/>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <Controller
                                                            control={control}
                                                            name={"birth_place"}
                                                            render={({field, fieldState}) => (
                                                                <TextField fullWidth
                                                                           label={t('editBlackList.birthPlace')}
                                                                           value={field.value} margin="dense"
                                                                           variant="standard"
                                                                           disabled={!newCustomer}
                                                                           onChange={field.onChange}
                                                                           required={newCustomer}
                                                                           error={!!fieldState.error}
                                                                           helperText={fieldState.error?.message}
                                                                />
                                                            )}/>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <Controller
                                                            control={control}
                                                            name={"birth_county"}
                                                            render={({field, fieldState}) => (
                                                                <TextField fullWidth
                                                                           label={t('editBlackList.countyRegion')}
                                                                           value={field.value} margin="dense"
                                                                           variant="standard"
                                                                           disabled={!newCustomer}
                                                                           onChange={field.onChange}
                                                                           required={newCustomer}
                                                                           error={!!fieldState.error}
                                                                           helperText={fieldState.error?.message}
                                                                />
                                                            )}/>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <Controller
                                                            control={control}
                                                            name={"birth_country"}
                                                            render={({field, fieldState}) => (
                                                                <TextField fullWidth label={t('editBlackList.country')}
                                                                           value={field.value} margin="dense"
                                                                           variant="standard"
                                                                           disabled={!newCustomer}
                                                                           onChange={field.onChange}
                                                                           required={newCustomer}
                                                                           error={!!fieldState.error}
                                                                           helperText={fieldState.error?.message}
                                                                />
                                                            )}/>
                                                    </Grid>
                                                </>
                                            }
                                            <Grid item xs={3}>
                                                <Controller
                                                    control={control}
                                                    name={"tax_code"}
                                                    render={({field, fieldState}) => (
                                                        <TextField
                                                            fullWidth label={t('editBlackList.taxCode')}
                                                            value={field.value} margin="dense" variant="standard"
                                                            onChange={field.onChange}
                                                            required={false}
                                                            disabled={newCustomer ? false : isReadonly}
                                                            error={!!fieldState.error}
                                                            helperText={fieldState.error?.message}
                                                        />
                                                    )}/>
                                            </Grid>
                                            {!isFCABankOrigin &&
                                                <Grid item xs={3}>
                                                    <Controller
                                                        control={control}
                                                        name={"license_number"}
                                                        render={({field, fieldState}) => (
                                                            <TextField fullWidth label={t('editBlackList.licence')}
                                                                       value={field.value} margin="dense"
                                                                       variant="standard"
                                                                       onChange={field.onChange}
                                                                       required={!isReadonly}
                                                                       error={!!fieldState.error}
                                                                       helperText={fieldState.error?.message}
                                                                       disabled={newCustomer ? false : isReadonly}

                                                            />
                                                        )}/>
                                                </Grid>
                                            }
                                            <Grid item xs={3}>
                                                <Controller
                                                    control={control}
                                                    name={"telephone_number"}
                                                    render={({field, fieldState}) => (
                                                        <TextField fullWidth label={t('editBlackList.phoneNumber')}
                                                                   value={field.value} margin="dense" variant="standard"
                                                                   onChange={field.onChange}
                                                                   required={!isReadonly}
                                                                   error={!!fieldState.error}
                                                                   helperText={fieldState.error?.message}
                                                                   disabled={newCustomer ? false : isReadonly}
                                                        />
                                                    )}/>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Controller
                                                    control={control}
                                                    name={"email"}
                                                    render={({field, fieldState}) => (
                                                        <TextField fullWidth label={t('editBlackList.email')}
                                                                   value={field.value} margin="dense" variant="standard"
                                                                   onChange={field.onChange}
                                                                   required={!isReadonly}
                                                                   error={!!fieldState.error}
                                                                   helperText={fieldState.error?.message}
                                                                   disabled={newCustomer ? false : isReadonly}
                                                        />
                                                    )}/>
                                            </Grid>

                                            <Grid item xs={3}>
                                                <Controller
                                                    control={control}
                                                    name={"client_type.client_type_code"}
                                                    render={({field, fieldState}) => (
                                                        <TextField
                                                            fullWidth
                                                            label={t('filters.clientType')}
                                                            select
                                                            required
                                                            disabled={!newCustomer}
                                                            value={field.value}
                                                            onChange={field.onChange}
                                                            error={!!fieldState.error}
                                                            helperText={fieldState.error?.message}
                                                        >
                                                            {client_type.map(((le: any) => (
                                                                <MenuItem key={le.client_type_code}
                                                                          value={le.client_type_code}>
                                                                    {getClientTypeLabel(le.client_type_code)}
                                                                </MenuItem>
                                                            )))}
                                                        </TextField>
                                                    )}/>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Controller
                                                    control={control}
                                                    name={"causal.causal_code"}
                                                    render={({field, fieldState}) => (
                                                        <TextField
                                                            fullWidth
                                                            name="causal"
                                                            label={t('filters.causal')}
                                                            select
                                                            required={!isReadonly}
                                                            value={field.value}
                                                            onChange={field.onChange}
                                                            error={!!fieldState.error}
                                                            disabled={newCustomer ? false : isFCABankOrigin ? true : isReadonly}
                                                            helperText={fieldState.error?.message}
                                                        >
                                                            {causalValues.map((l: any) => (
                                                                <MenuItem key={l.causal_code} value={l.causal_code}>
                                                                    {getCausalLabel(l.causal_code)}
                                                                </MenuItem>
                                                            ))}
                                                        </TextField>
                                                    )}/>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Controller
                                                    control={control}
                                                    name={isFCABankOrigin ? "fca_notes" : "notes"}
                                                    render={({field, fieldState}) => (
                                                        <TextField fullWidth name="notes"
                                                                   label={t('editBlackList.note')}
                                                                   value={isFCABankOrigin ? (watch("fca_notes") + " - " + getFCABankLabel(watch("fca_notes"))) : field.value}
                                                                   margin="dense" variant="standard"
                                                                   disabled={newCustomer ? false : isFCABankOrigin ? true : isReadonly}
                                                                   onChange={field.onChange}
                                                                   error={!!fieldState.error}
                                                                   helperText={fieldState.error?.message}
                                                        />
                                                    )}/>
                                            </Grid>
                                            {/*End managment Private Customer View*/}
                                        </>
                                        :
                                        <>
                                            {/*Manage Company View */}
                                            <Grid item xs={3}>
                                                <Controller
                                                    control={control}
                                                    name={"business_name"}
                                                    render={({field, fieldState}) => (
                                                        <TextField fullWidth label={t('editBlackList.businessName')}
                                                                   value={field.value} margin="dense" variant="standard"
                                                                   disabled={!newCustomer}
                                                                   onChange={field.onChange}
                                                                   error={!!fieldState.error}
                                                                   helperText={fieldState.error?.message}
                                                                   required={newCustomer}
                                                        />
                                                    )}/>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Controller
                                                    control={control}
                                                    name={"vat_number"}
                                                    render={({field, fieldState}) => (
                                                        <TextField
                                                            fullWidth label={t('editBlackList.vatNumber')}
                                                            value={field.value} margin="dense" variant="standard"
                                                            onChange={field.onChange}
                                                            required={!isReadonly}
                                                            disabled={!newCustomer}
                                                            error={!!fieldState.error}
                                                            helperText={fieldState.error?.message}
                                                        />
                                                    )}/>
                                            </Grid>
                                            {(customer && customer?.siren !== "") &&
                                                <>
                                                    <Grid item xs={3}>
                                                        <Controller
                                                            control={control}
                                                            name={"siren"}
                                                            render={({field, fieldState}) => (
                                                                <TextField
                                                                    fullWidth label={t('editBlackList.siren')}
                                                                    value={field.value} margin="dense"
                                                                    variant="standard"
                                                                    onChange={field.onChange}
                                                                    required={!isReadonly}
                                                                    disabled={true}
                                                                    error={!!fieldState.error}
                                                                    helperText={fieldState.error?.message}
                                                                />
                                                            )}/>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <Controller
                                                            control={control}
                                                            name={"siret"}
                                                            render={({field, fieldState}) => (
                                                                <TextField
                                                                    fullWidth label={t('editBlackList.siret')}
                                                                    value={field.value} margin="dense"
                                                                    variant="standard"
                                                                    onChange={field.onChange}
                                                                    required={!isReadonly}
                                                                    disabled={true}
                                                                    error={!!fieldState.error}
                                                                    helperText={fieldState.error?.message}
                                                                />
                                                            )}/>
                                                    </Grid>
                                                </>
                                            }
                                            <Grid item xs={3}>
                                                <Controller
                                                    control={control}
                                                    name={"client_type.client_type_code"}
                                                    render={({field, fieldState}) => (
                                                        <TextField
                                                            fullWidth
                                                            label={t('filters.clientType')}
                                                            select
                                                            required={newCustomer}
                                                            disabled={!newCustomer}
                                                            value={field.value}
                                                            onChange={field.onChange}
                                                            error={!!fieldState.error}
                                                            helperText={fieldState.error?.message}
                                                        >
                                                            {client_type.map(((le: any) => (
                                                                <MenuItem key={le.client_type_code}
                                                                          value={le.client_type_code}>
                                                                    {getClientTypeLabel(le.client_type_code)}
                                                                </MenuItem>
                                                            )))}
                                                        </TextField>
                                                    )}/>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Controller
                                                    control={control}
                                                    name={"email"}
                                                    render={({field, fieldState}) => (
                                                        <TextField fullWidth label={t('editBlackList.email')}
                                                                   value={field.value} margin="dense" variant="standard"
                                                                   onChange={field.onChange}
                                                                   required={!isReadonly}
                                                                   disabled={newCustomer ? false : isReadonly}
                                                                   error={!!fieldState.error}
                                                                   helperText={fieldState.error?.message}
                                                        />
                                                    )}/>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Controller
                                                    control={control}
                                                    name={"telephone_number"}
                                                    render={({field, fieldState}) => (
                                                        <TextField fullWidth label={t('editBlackList.phoneNumber')}
                                                                   value={field.value} margin="dense" variant="standard"
                                                                   onChange={field.onChange}
                                                                   required={!isReadonly}
                                                                   disabled={newCustomer ? false : isReadonly}
                                                                   error={!!fieldState.error}
                                                                   helperText={fieldState.error?.message}
                                                        />
                                                    )}/>
                                            </Grid>

                                            <Grid item xs={3}>
                                                <Controller
                                                    control={control}
                                                    name={"causal.causal_code"}
                                                    render={({field, fieldState}) => (
                                                        <TextField
                                                            fullWidth
                                                            name="causal"
                                                            label={t('filters.causal')}
                                                            select
                                                            required={!isReadonly}
                                                            disabled={newCustomer ? false : isReadonly}
                                                            value={field.value}
                                                            onChange={field.onChange}
                                                            error={!!fieldState.error}
                                                            helperText={fieldState.error?.message}

                                                        >
                                                            {
                                                                causalValues.map((l: any) => (
                                                                    <MenuItem key={l.causal_code}
                                                                              value={l.causal_code}>
                                                                        {getCausalLabel(l.causal_code)}
                                                                    </MenuItem>
                                                                ))
                                                            }
                                                        </TextField>
                                                    )}/>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Controller
                                                    control={control}
                                                    name={"notes"}
                                                    render={({field, fieldState}) => (
                                                        <TextField fullWidth name="notes"
                                                                   label={t('editBlackList.note')}
                                                                   value={field.value} margin="dense" variant="standard"
                                                                   disabled={newCustomer ? false : isFCABankOrigin ? true : isReadonly}
                                                                   onChange={field.onChange}
                                                                   error={!!fieldState.error}
                                                                   helperText={fieldState.error?.message}
                                                        />
                                                    )}/>
                                            </Grid>
                                            {/* END Managment Company View */}
                                        </>
                                    }
                                    {!newCustomer &&
                                        <>
                                            <Grid item xs={6}>
                                                <Controller
                                                    control={control}
                                                    name={"entry_user_bl"}
                                                    render={({field, fieldState}) => (
                                                        <TextField fullWidth label={t('editBlackList.userEntry')}
                                                                   value={field.value} margin="dense" variant="standard"
                                                                   disabled={!newCustomer}
                                                                   onChange={field.onChange}
                                                                   error={!!fieldState.error}
                                                                   helperText={fieldState.error?.message}
                                                        />
                                                    )}/>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Controller
                                                    control={control}
                                                    name={"entry_origin.entry_origin_code"}
                                                    render={({field, fieldState}) => (
                                                        <TextField
                                                            fullWidth
                                                            label={t('filters.entrySource')}
                                                            select
                                                            disabled={!newCustomer}
                                                            value={field.value}
                                                            onChange={field.onChange}
                                                            error={!!fieldState.error}
                                                            helperText={fieldState.error?.message}
                                                        >
                                                            {entrySource.map(((le: any) => (
                                                                <MenuItem key={le.entry_origin_code}
                                                                          value={le.entry_origin_code}>
                                                                    {getEntrySourcelLabel(le.entry_origin_code)}
                                                                </MenuItem>
                                                            )))}
                                                        </TextField>
                                                    )}/>
                                            </Grid>
                                        </>
                                    }
                                </Grid>

                                {/*Buttons managment*/}
                                {!newCustomer ?
                                    <>
                                        {(isReadonly && customer) && showTemplateAttachment()}

                                        <Grid container rowSpacing={3} columnSpacing={3} sx={{paddingTop: "50px"}}>
                                            <Grid container item xs={12} rowSpacing={1} columnSpacing={3}
                                                  justifyContent={"flex-end"}>
                                                {!isReadonly &&
                                                    <>
                                                        {hasScope(BLACK_LIST_SCOPE_EDIT) &&
                                                            <>
                                                                <Grid item>
                                                                    <Button variant={"outlined"} color={"accent"}
                                                                            onClick={() => {
                                                                                if (formIsDirty) {
                                                                                    setOpenCancelAddCustomer(true);
                                                                                } else {
                                                                                    reset(retrieveInitialValues());
                                                                                    setIsReadonly(prevState => !prevState);
                                                                                    navigate(`/finessecurity/watchlist/detail/${customer?.id}`);
                                                                                }
                                                                            }}>
                                                                        {t('buttons.cancel')}
                                                                    </Button>
                                                                </Grid>
                                                                <Grid item>
                                                                    <Button color={"accent"} type="submit">
                                                                        {t('buttons.save')}
                                                                    </Button>
                                                                </Grid>
                                                            </>
                                                        }
                                                    </>
                                                }

                                                {!isArchived &&
                                                    <>
                                                        {isReadonly &&
                                                            <Grid item>
                                                                {(hasScope(BLACK_LIST_SCOPE_ARCHIVE) && hasScope(BLACK_LIST_SCOPE_EDIT)) &&
                                                                    <Button
                                                                        onClick={() => setOpenArchiveModal(true)}>
                                                                        <Archive/> {t('buttons.archive')}
                                                                    </Button>}
                                                            </Grid>
                                                        }
                                                    </>
                                                }
                                            </Grid>
                                        </Grid>
                                    </>
                                    :
                                    <>
                                        {hasScope(BLACK_LIST_SCOPE_CREATE) &&
                                            <Grid container rowSpacing={3} columnSpacing={3} sx={{paddingTop: "50px"}}>
                                                <Grid container item xs={12} rowSpacing={1} columnSpacing={3}
                                                      justifyContent={"flex-end"}>
                                                    <Grid item>
                                                        <Button variant={"outlined"} color={"accent"}
                                                                onClick={() => {
                                                                    formIsDirty ? setOpenCancelAddCustomer(true) :
                                                                        customerDetailsExternal ?
                                                                            navigate(-1)
                                                                            : navigate("/finessecurity/watchlist")
                                                                }}>
                                                            {t('buttons.cancel')}
                                                        </Button>
                                                    </Grid>
                                                    <Grid item>
                                                        <Button color={"accent"}
                                                                type="submit">{t('buttons.addToBlackList')}
                                                        </Button>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        }
                                    </>
                                }
                            </>
                            :
                            <div/>
                        }
                    </form>

                    : <NotAuthorizedDialog/>}
            </Paper>

            <CustomModalBL title={!newCustomer ? t('updateForm.modalTitleSuccess') : t('createForm.modalTitleSuccess')}
                           content={!newCustomer ? t('updateForm.modalDescriptionSuccess') : t('createForm.modalDescriptionSuccess')}
                           cancelButton={t('buttons.close')}
                           open={openCreationModal}
                           titleIcon={<CheckCircleRounded color={"success"}/>}
                           onClose={() => {
                               setOpenCreationModal(false);
                               if (newCustomer) {
                                   navigate(`/finessecurity/watchlist`);
                               } else {
                                   navigate(`/finessecurity/watchlist/detail/${customer?.id}`);
                               }
                           }}
            />
            <CustomModalBL title={t('updateForm.archiveInformation')}
                           content={t('updateForm.archiveMessage',
                               {
                                   customerName: isFCABankOrigin ? customer?.full_name :
                                       (isPrivateCustomer ? (customer?.last_name + " " + customer?.first_name)
                                           : customer?.business_name)
                               })}
                           cancelButton={t('buttons.cancel')}
                           saveButton={t('buttons.archive')}
                           open={openArchiveModal}
                           titleIcon={<InfoRoundedIcon/>}
                           onClose={() => {
                               setOpenArchiveModal(false);
                           }}
                           onSave={() => {
                               const payload = getValues();
                               archiveCustomer(payload).then(res => {
                                   setOpenArchiveModal(false);
                                   navigate(`/finessecurity/watchlist/archived`);
                               });

                           }}
            />
            <CustomModalBL title={t('updateForm.deleteConfirmation')}
                           content={t('updateForm.deleteConfirmationMsg', {fileName: attachmentRowName})}
                           cancelButton={t('buttons.cancel')}
                           saveButton={t('buttons.deleteDocument')}
                           open={openDeleteAttachmentModal}
                           titleIcon={<InfoRoundedIcon/>}
                           onClose={() => {
                               setOpenDeleteAttachmentModal(false);
                           }}
                           onSave={() => {
                               setOpenDeleteAttachmentModal(false);
                               deleteBlackListAttachment(attachmentRowId, id).then(res =>
                                   getBlackListDetail(id).then(res => {
                                        console.log('BlackListDetailPage getBlackListDetail (4) res: ' + JSON.stringify(res));
                                       setCustomer(res);
                                   })
                               )
                           }}
            />

            <CustomModalBL title={t('updateForm.unsavedChanges')}
                           content={t('updateForm.discardCustomerMessage')}
                           cancelButton={t('updateForm.discardChanges')}
                           saveButton={t('updateForm.keepEditing')}
                           isDisabled={false}
                           open={openCancelAddCustomer}
                           titleIcon={<InfoRoundedIcon/>}
                           onClose={() => {
                               setOpenCancelAddCustomer(false);
                           }}
                           onCancel={() => {
                               if (newCustomer) {
                                   setOpenCancelAddCustomer(false);
                                   customerDetailsExternal ?
                                       navigate(-1)
                                       : navigate("/finessecurity/watchlist")
                               } else {
                                   reset(retrieveInitialValues());
                                   setIsReadonly(prevState => !prevState);
                                   setOpenCancelAddCustomer(false);
                                   customerDetailsExternal ?
                                       navigate(-1)
                                       : navigate(`/finessecurity/watchlist/detail/${customer?.id}`);
                               }
                           }}
                           onSave={() => {
                               setOpenCancelAddCustomer(false);
                           }}
            />
            <CustomModalBL open={openCreationModalError} title={t('importErrors.blacklistingError')}
                           content={t('importErrors.errorOnAddingCustomerToBlacklist', {
                               causal: customer ?
                                   getCausalLabel(customer?.causal.causal_code) : ""
                           })}
                           cancelButton={t('buttons.cancel')}
                           saveButton={''}
                           titleIcon={<InfoRoundedIcon/>}
                           onClose={() => {
                               setOpenCreationModalError(false);
                           }}

            />
            <CustomModalBL open={openTaxCodeModalError} title={t('importErrors.missingTaxCode')}
                           content={t('importErrors.errorOnFiscalCode')}
                           cancelButton={t('buttons.cancel')}
                           saveButton={t('buttons.confirm')}
                           titleIcon={<InfoRoundedIcon/>}
                           onSave={() => {
                               setOpenTaxCodeModalError(false)
                               addOrUpdateCustomer(getValues());
                           }}
                           onClose={() => {
                               setOpenTaxCodeModalError(false);
                           }}

            />

        </>
    );

    function showTemplateAttachment() {
        return (
            <>
                <Grid item xs={12} sx={{padding: "16px"}}>
                    <AgGridCustomTable gridOptions={gridOptions} gridRef={gridRef} toolbar={toolbar}
                                       rowData={customer ? customer?.attachments : []}/>
                </Grid>
            </>
        )
    }
}

export default BlackListDetailPage;